import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class CouponError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('CouponError', ...args);
    }
}
export default CouponError;
